export const CreditIcon = ({ color = '#0064ff', ...props }) => (
  <svg
    width={'18'}
    height={'15'}
    viewBox={'0 0 18 15'}
    fill={'none'}
    xmlns={'http://www.w3.org/2000/svg'}
    {...props}
  >
    <path
      fillRule={'evenodd'}
      clipRule={'evenodd'}
      d={'M0.88347 5.11998C0.401476 5.11998 0.0107422 4.72925 0.0107422 4.24726V2.5018C0.0107422 1.53781 0.79221 0.756348 1.7562 0.756348H15.7198C16.6838 0.756348 17.4653 1.53781 17.4653 2.5018V4.24726C17.4653 4.72925 17.0746 5.11998 16.5926 5.11998H0.88347ZM0.88347 7.73817C0.401476 7.73817 0.0107422 8.1289 0.0107422 8.61089V12.9745C0.0107422 13.9385 0.79221 14.72 1.7562 14.72H15.7198C16.6838 14.72 17.4653 13.9385 17.4653 12.9745V8.61089C17.4653 8.1289 17.0746 7.73817 16.5926 7.73817H0.88347Z'}
      fill={color}
    />
  </svg>
);
